import {
    takeLatest,
    put
} from 'redux-saga/effects';
import { push } from 'react-router-redux';

import { Http } from '@app-masters/js-lib';

import { takeFirst } from './helperSaga';
import { ACTIONS } from '../actions/actionTypes';
import { ACTIONS as AUTH_ACTIONS } from '../containers/Auth/auth.actionTypes';
import * as game from '../controllers';
import errorCatcher from '../utils/errorCatcher';

const localStorage = window.localStorage;

// USER_UPDATE_LOCAL_DATA IS CALLED WHENEVER WE NEED TO UPDATE THE USER DATA LOCALLY
export function * USER_UPDATE_LOCAL_DATA () {
    yield takeFirst(ACTIONS.USER_UPDATE_LOCAL_DATA, function * (action) {
        try {
            localStorage.setItem('user', JSON.stringify(action.payload));
            if (action.payload.local) {
                delete action.payload['local'];
            }
            yield put({type: ACTIONS.USER_SET_DATA, payload: action.payload});
        } catch (err) {
            errorCatcher(err);
        }
    });
}

// Update the user's data on the api and call the update local data to update its reducer and localStorage information
export function * USER_UPDATE_REMOTE_DATA () {
    yield takeLatest(ACTIONS.USER_UPDATE_REMOTE_DATA, function * (action) {
        try {
            console.log(action.payload);
            if (action.payload.local) {
                delete action.payload['local'];
            }
            yield put({type: ACTIONS.USER_SET_LOADING_DATA, payload: true});
            const result = yield game.user.update(action.payload);
            console.log(result);

            yield put({type: ACTIONS.USER_UPDATE_LOCAL_DATA, payload: result});

            yield put({type: ACTIONS.USER_SET_LOADING_DATA, payload: false});
        } catch (err) {
            errorCatcher(err);
        }
    });
}

export function * USER_UPDATE_OTHER_USER () {
    yield takeLatest(ACTIONS.USER_UPDATE_OTHER_USER, function * (action) {
        try {
            if (action.payload.local) {
                delete action.payload['local'];
            }
            const result = yield game.user.update(action.payload);
            console.log(result);
        } catch (err) {
            errorCatcher(err);
        }
    });
}

// Restarts the game
export function * RESTART_GAME () {
    yield takeLatest(ACTIONS.RESTART_GAME, function * (action) {
        try {
            const user = yield Http.post(`/user/{_id}/restartgame`);
            yield put({type: ACTIONS.USER_UPDATE_LOCAL_DATA, payload: user});
            yield put(push('/enem'));
            yield put({type: ACTIONS.CLOSE_PROFILE_MODAL});
            // yield put({type: ACTIONS.GET_DASHBOARD});
            // location.reload();
        } catch (err) {
            errorCatcher(err);
        }
    });
}

export function * AUTH_LOGOUT_USER () {
    yield takeLatest(AUTH_ACTIONS.AUTH_LOGOUT_USER, function * (action) {
        yield put({type: ACTIONS.S_APP_REDIRECT, payload: false});
        yield put(push('/'));
    });
}



// WEBPACK FOOTER //
// ./src/sagas/userSaga.js